export const spacing = [0, 4, 8, 16, 24, 32, 40, 48, 56];
